import React, {
  useState,
  useRef,
  useCallback,
  useEffect,
  useMemo,
} from "react";
import { useParams, useNavigate } from "react-router-dom";
import ReactFlow, {
  ReactFlowProvider,
  addEdge,
  SmoothStepEdge,
  useNodesState,
  useEdgesState,
  Controls,
  Background,
  BackgroundVariant,
  MarkerType,
} from "reactflow";
import "reactflow/dist/style.css";
import Sidebar from "./Sidebar";
import "./Flow.css";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "../../../assets/css/templateBuilder.css";
import "../../../assets/css/addunit.css";
import "../../../assets/css/mainMenu.css";

import trash from "../../../assets/icons/trash.svg";
import edit from "../../../assets/icons/edit.svg";
import search1 from "../../../assets/icons/search1.svg";
import close from "../../../assets/icons/close.svg";
import folder from "../../../assets/icons/folder.svg";

import ImageNode from "./ImageNode";
import InitialNode from "./InitialNode";
import DefaultNode from "./DefaultNode";
import Loader from "../../../Components/LoaderAndSpinner/Loader";

import fetchWrapper from "./../../../AuthMiddleware/FetchWrapper";
const EditAsset = () => {
  const [previousFieldValue, setPreviousFieldValue] = useState("");

  const [loading, setLoading] = useState(false);
  const reactFlowWrapper = useRef(null);
  const [master, setMaster] = useState([]);
  const [nodes, setNodes, onNodesChange] = useNodesState([]);
  const [edges, setEdges, onEdgesChange] = useEdgesState([]);
  const [reactFlowInstance, setReactFlowInstance] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  // const [assetId, setAssetId] = useState("");
  const [templateId, setTemplateId] = useState();
  const [isModalconfigOpen, setIsModalconfigOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isTemplateModalOpen, setIsTemplateModalOpen] = useState(false);
  const [isAttributeModalOpen, setIsAttributeModalOpen] = useState(false);
  const [selectedNode, setSelectedNode] = useState(null); // Track selected node
  const [editElementId, setEditElementId] = useState(""); // Track selected node id

  const [uniqueCheckboxes, setUniqueCheckboxes] = useState({});

  const [contextMenu, setContextMenu] = useState({
    isOpen: false,
    position: { x: 0, y: 0 },
  });
  // const [attributeMenu, setAttributeMenu] = useState({
  //   isOpen: false,
  //   position: { x: 0, y: 0 },
  // });
  const [usedTemplateTypeIds, setUsedTemplateTypeIds] = useState([]); // State to track used nodes
  const [edgeToDelete, setEdgeToDelete] = useState(null); // Track edge to delete
  const [edgeLabelModal, setEdgeLabelModal] = useState({
    isOpen: false,
    label: "",
    edgeId: null,
  }); // New state for edge label modal
  const templateNameRef = useRef(null);
  const templateCodeRef = useRef(null);
  const [templateName, setTemplateName] = useState("");
  const [parameters, setParameters] = useState([]);
  const [selectedMasters, setSelectedMasters] = useState([]);
  const [templateNameInput, setTemplateNameInput] = useState("");
  const [templateCodeInput, setTemplateCodeInput] = useState("");
  const [attributes, setAttributes] = useState([]);
  const [templateAttributes, setTemplateAttributes] = useState([]);
  const [templateMasters, setTemplateMasters] = useState([]);
  // const [allCheckedMasters, setAllCheckedMasters] = useState(false);
  const [checkedTemplateMasters, setCheckedTemplateMasters] = useState([]);
  const [allChecked, setAllChecked] = useState(false);
  const [checkedItems, setCheckedItems] = useState([]);
  const { template_type_id, asset_id } = useParams();
  const [errors, setErrors] = useState({});
  const [shouldFetch, setShouldFetch] = useState(false);
  const [order1, setorder1] = useState();
  const [row_limit1, setRowLimit1] = useState();
  // setAssetId(asset_id);
  const [newTemplateAttribute, setNewTemplateAttribute] = useState({
    asset_id: "",
    template_id: "",
    field_name: "",
    field_type: "",
    field_value: [],
    display_name: "",
    required: false,
    master_id: "",
    parameter_type_id: "",
  });
  const [editTemplateAttribute, setEditTemplateAttribute] = useState({
    asset_id: "",
    template_id: "",
    field_name: "",
    field_type: "",
    field_value: [],
    display_name: "",
    required: false,
    master_id: "",
    parameter_type_id: "",
  });
  const [editSpecializationName, setEditSpecializationName] = useState("");
  const [confirmModal, setConfirmModal] = useState(false);

  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [tableSearchQueries, setTableSearchQueries] = useState({});
  const [confirm, setConfirm] = useState(false);
  const [filteredTemplateMasters, setFilteredTemplateMasters] =
    useState(templateMasters);

  const nodeTypes = useMemo(
    () => ({
      imageNode: ImageNode,
      initialNode: InitialNode,
      defaultNode: DefaultNode,
    }),
    []
  );

  const edgeTypes = useMemo(
    () => ({
      smoothstep: SmoothStepEdge,
    }),
    []
  );

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const fetchMasterValues = async (masterId) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/get-masters`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json", // IMPORTANT
          },
          body: JSON.stringify({ masterId }), // Make sure this is a JSON string
        }
      );
      if (!response.ok) {
        throw new Error("Failed to fetch master values");
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching master values:", error);
      return [];
    }
  };

  const fetchNodes = async () => {
    const apiUrl = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/template-by-type`;

    try {
      // Ensure template_type_id is defined
      const requestBody = {
        template_type_id: template_type_id, // Assuming template_type_id is defined
      };

      // Use fetchWrapper for API call
      const response = await fetchWrapper(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      setMaster(response); // Assuming setMaster is used to set state
    } catch (error) {
      console.error("Fetch error:", error);
      setMaster([]); // Handle error by setting master to an empty array
    }
  };

  const fetchAttributes = () => {
    const apiUrl = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/asset-attributes/getall`;

    fetchWrapper(
      apiUrl,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      },
      navigate
    )
      .then((data) => {
        setAttributes(data.data);
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        setAttributes([]);
      });
  };

  // const handleOrderChange = (id, newOrder) => {
  //   setAttributes((prevAttributes) =>
  //     prevAttributes.map((attribute) =>
  //       attribute._id === id
  //         ? { ...attribute, order: Number(newOrder) }
  //         : attribute
  //     )
  //   );
  // };

  const fetchTemplateMasters = async () => {
    try {
      const templateId = selectedNode.id;
      const apiUrl = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/template-masters/${templateId}/leaf`;

      const data = await fetchWrapper(
        apiUrl,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        },
        navigate
      );

      setTemplateMasters(data.groups); // Assuming setTemplateMasters is a state updater function
    } catch (error) {
      console.error("Fetch error for template masters:", error);
      setTemplateMasters([]); // Handle error by setting templateMasters to an empty array
      // Optionally handle other state updates or error-specific actions
    }
  };
  const fetchAddedAssetMaster = async () => {
    try {
      const templateId = selectedNode.id;
      const assetId = asset_id; // Ensure asset_id is defined

      const apiUrl = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/asset-master/${assetId}/${templateId}`;

      const data = await fetchWrapper(
        apiUrl,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        },
        navigate
      );

      // Map through the fetched data and set the checkbox selection
      const fetchedItems = data.data.map((item) => ({
        template_master_id: item.template_master_id._id,
        document_code: item.template_master_id.document_code,
      }));

      setCheckedTemplateMasters((prevCheckedItems) => {
        const updatedCheckedItems = [...prevCheckedItems];
        fetchedItems.forEach((fetchedItem) => {
          const isChecked = prevCheckedItems.some(
            (item) => item.template_master_id === fetchedItem.template_master_id
          );
          if (!isChecked) {
            updatedCheckedItems.push(fetchedItem);
          }
        });
        // setAllCheckedMasters(
        //   updatedCheckedItems.length === templateMasters.length
        // );
        return updatedCheckedItems;
      });

      // Optionally, setAllCheckedMasters if needed
      // setAllCheckedMasters(fetchedItems.length === templateMasters.length);
    } catch (error) {
      console.error("Fetch error for selected Asset Masters:", error);
      setCheckedTemplateMasters([]);
      // Optionally handle other error-specific actions or state updates
    }
  };
  const fetchSelectedAttributes = async () => {
    try {
      const apiUrl = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/asset-class-attribute/${asset_id}`;

      const data = await fetchWrapper(
        apiUrl,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        },
        navigate
      );


      const selectedItems = data.asset_attributes.map(
        (attribute) => attribute._id
      );
      setCheckedItems(selectedItems);
      // Update attributes with the order information
      const updatedAttributes = attributes.map((attr) => {
        const selectedAttribute = data.asset_attributes.find(
          (item) => item._id === attr._id
        );
        return selectedAttribute
          ? { ...attr, order: selectedAttribute.order }
          : attr;
      });
      setAttributes(updatedAttributes);
      if (attributes.length !== null) {
        setAllChecked(selectedItems.length === attributes.length);
      }
    } catch (error) {
      console.error("Fetch error for selected attributes:", error);
      setCheckedItems([]);
      // Optionally handle other error-specific actions or state updates
    }
  };
  const fetchTemplateAttributes = async () => {
    try {
      const templateId = selectedNode.id;

      const apiUrl = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/template-attribute/${asset_id}/${templateId}`;

      const data = await fetchWrapper(
        apiUrl,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        },
        navigate
      );

      setTemplateAttributes(data);
    } catch (error) {
      setTemplateAttributes([]);
      // Optionally handle other error-specific actions or state updates
    }
  };
  const onConnect = useCallback(
    (params) =>
      setEdges((eds) =>
        addEdge(
          {
            ...params,
            type: "smoothstep",
            markerEnd: { type: MarkerType.ArrowClosed },
            label: "",
          },
          eds
        )
      ),
    []
  );

  const onDragOver = useCallback((event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = "move";
  }, []);

  const onDrop = useCallback(
    (event) => {
      event.preventDefault();

      if (!reactFlowWrapper.current) {
        return;
      }

      const reactFlowBounds = reactFlowWrapper.current.getBoundingClientRect();
      const masterId = event.dataTransfer.getData("application/reactflow");

      // Ensure the drop happens within the bounds of the canvas
      if (
        typeof masterId === "undefined" ||
        !masterId ||
        !reactFlowInstance ||
        !master.length
      ) {
        return;
      }

      const position = reactFlowInstance.project({
        x: event.clientX - reactFlowBounds.left,
        y: event.clientY - reactFlowBounds.top,
      });

      // const masterDataItem = master.masters.find((m) => m._id === masterId);

      const masterDataItem = master.find((templateType) =>
        templateType.templates.some((template) => template._id === masterId)
      );

      const foundTemplate = masterDataItem
        ? masterDataItem.templates.find((template) => template._id === masterId)
        : null;

      if (!masterDataItem) {
        console.warn(`Master item not found for ID: ${masterId}`);
        return;
      }

      const newNode = {
        id: `${masterId}`, // Use `masterId` as the unique identifier
        type: "defaultNode", // Determine the node type
        position,
        sourcePosition: ["right", "left", "top", "bottom"],
        data: {
          label: foundTemplate.template_name, // Use correct name
          img: foundTemplate.img, // Include image if present
        },
      };

      setNodes((nds) => nds.concat(newNode));
      setUsedTemplateTypeIds((prev) => [
        ...prev,
        masterDataItem.templateType._id,
      ]); // Add the template type ID to the used list
    },
    [reactFlowInstance, master, nodes, usedTemplateTypeIds] // Dependencies
  );

  const closeModal = () => {
    setIsModalOpen(false); // Close the modal
    setSelectedNode(null); // Reset the selected node
  };
  const closeModalconfig = () => {
    setIsModalconfigOpen(false);
    setSelectedNode(null);
  };

  const closeViewModal = () => {
    setIsViewModalOpen(false); // Close the modal
    // setSelectedNode(null); // Reset the selected node
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false); // Close the modal
    //setSelectedNode(null); // Reset the selected node
  };

  const closeTemplateModal = () => {
    setUniqueCheckboxes({});
    setIsTemplateModalOpen(false); // Close the modal
    setSelectedNode(null); // Reset the selected node
  };

  const closeAttributeModal = () => {
    setIsAttributeModalOpen(false); // Close the modal
    setSelectedNode(null);
    setIsViewModalOpen(false); // Close the modal
    // isViewModalOpen // Reset the selected node
  };

  const openEdgeLabelModal = (edgeId) => {
    // Fetch the correct edge from the current state
    const edge = edges.find((e) => e.id === edgeId);
    const currentLabel = edge?.label || ""; // Get existing label or default to empty
    setEdgeLabelModal({ isOpen: true, label: currentLabel, edgeId }); // Open modal with current label
  };

  // Function to handle adding a label to an edge
  const addLabelToEdge = (edgeId, label) => {
    setEdges((eds) =>
      eds.map((edge) =>
        edge.id === edgeId
          ? { ...edge, label } // Update edge with new label
          : edge
      )
    );
    setEdgeLabelModal({ isOpen: false, label: "", edgeId: null }); // Close modal after updating label
  };

  const onEdgeClick = (event, edge) => {
    event.stopPropagation(); // Stop propagation to avoid interfering with other clicks

    closeContextMenu();
    // closeAttributeMenu();
    if (!reactFlowWrapper.current) {
      return;
    }

    const reactFlowBounds = reactFlowWrapper.current.getBoundingClientRect();
    const xPosition = event.clientX - reactFlowBounds.left;
    const yPosition = event.clientY - reactFlowBounds.top;
    setEdgeToDelete({ id: edge.id, position: { x: xPosition, y: yPosition } }); // Capture edge ID and position
  };

  const onDeleteEdge = () => {
    if (edgeToDelete) {
      setEdges((eds) => eds.filter((edge) => edge.id !== edgeToDelete.id)); // Delete the specified edge
      setEdgeToDelete(null); // Reset the edge to delete
    }
  };

  const onNodeDoubleClick = (event, node) => {
    event.preventDefault();

    if (edgeToDelete) {
      setEdgeToDelete(null); // Hide the delete button when clicking outside
    }
    if (node.id === "initial-node") {
      setIsModalOpen(false);
      setIsTemplateModalOpen(false);
      fetchSelectedAttributes();
      setIsAttributeModalOpen(true);
    } else {
      setSelectedNode(node);
      // setSelectedNodeId(node.id)

      setIsAttributeModalOpen(false);
      setShouldFetch(true); // Trigger the fetch
      // fetchTemplateMasters()
      // fetchAddedAssetMaster()
      setIsTemplateModalOpen(true);
    }
  };

  // Event handler for right-click on a node
  const onNodeContextMenu = (event, node) => {
    event.preventDefault(); // Prevent the default context menu

    if (edgeToDelete) {
      setEdgeToDelete(null); // Hide the delete button when clicking outside
    }
    if (!reactFlowWrapper.current) {
      return;
    }
    setTemplateId(node.id);

    const reactFlowBounds = reactFlowWrapper.current.getBoundingClientRect();
    const xOffset = 30;
    const yOffset = 150;

    if (node.id === "initial-node") {
      closeContextMenu();
      // setAttributeMenu({
      //   isOpen: true,
      //   position: {
      //     x: event.clientX - xOffset,
      //     y: event.clientY - reactFlowBounds.top + yOffset,
      //   },
      // })
    } else {
      // closeAttributeMenu();
      setContextMenu({
        isOpen: true,
        position: {
          x: event.clientX - xOffset,
          y: event.clientY - reactFlowBounds.top + yOffset,
        },
      });
      setSelectedNode(node);
    }
  };

  const closeContextMenu = () =>
    setContextMenu({ isOpen: false, position: { x: 0, y: 0 } });

  // const closeAttributeMenu = () =>
  //   setAttributeMenu({ isOpen: false, position: { x: 0, y: 0 } });

  const onDeleteNode = (nodeToDelete) => {
    // Helper function to get the template type ID based on the node ID
    const getTemplateTypeId = (master, templateId) => {
      for (const templateGroup of master) {
        const template = templateGroup.templates.find(
          (template) => template._id === templateId
        );
        if (template) {
          return template.template_type_id;
        }
      }
      return null; // return null if the template is not found
    };

    //    if (nodeToDelete.id !== 'initial-node' && nodeToDelete.id !== 'asset-attribute-node')
    if (nodeToDelete.id !== "initial-node") {
      // Remove the node from the list of nodes
      setNodes((nds) => nds.filter((node) => node.id !== nodeToDelete.id));

      // Remove all edges connected to the node
      setEdges((eds) =>
        eds.filter(
          (edge) =>
            edge.source !== nodeToDelete.id && edge.target !== nodeToDelete.id
        )
      );
    } else {
      toast.warn("you cannot delete this node");
    }

    const templateTypeId = getTemplateTypeId(master, nodeToDelete.id);

    if (templateTypeId) {
      setUsedTemplateTypeIds((used) =>
        used.filter((typeId) => typeId !== templateTypeId)
      );
    }

    closeContextMenu(); // Close the context menu after deletion
    // closeAttributeMenu(); // Close the attribute menu after deletion
  };

  const hideButton = () => {
    if (edgeToDelete) {
      setEdgeToDelete(null); // Hide the delete button when clicking outside
    }
    closeContextMenu();
    // closeAttributeMenu();
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      const nodesArray = [];
      const edgesArray = [];

      // Collect nodes in nodesArray
      nodes.forEach((node) => {
        const nodeObject = {
          id: node.id,
          type: node.type,
          style: { ...node.style },
          data: {
            ...node.data, // Includes parameter_type and label
          },
          position: {
            x: node.position.x.toFixed(2), // Fixing to 2 decimal places
            y: node.position.y.toFixed(2), // Fixing to 2 decimal places
          },
          sourcePosition: node.sourcePosition,
          targetPosition: node.targetPosition,
        };
        nodesArray.push(nodeObject);
      });

      // Collect edges in edgesArray
      edges.forEach((edge) => {
        edgesArray.push({
          id: `${edge.source}->${edge.target}`,
          source: edge.source,
          target: edge.target,
          label: edge.label,
          type: edge.type,
          markerEnd: { ...edge.markerEnd },
          sourceHandle: edge.sourceHandle, // Include the source Handle
          targetHandle: edge.targetHandle, // Include the target handle
        });
      });

      // Organize nodes and edges into separate sections in elements
      const elements = [{ nodes: nodesArray }, { edges: edgesArray }];

      const elementsJSON = JSON.stringify(elements, null, 2);

      // alert(elementsJSON); // Display JSON in an alert box

      // Await the async function
      await new Promise((resolve) => setTimeout(resolve, 0));

      const trimmedTemplateName = templateNameInput.trim();
      const trimmedTemplateCode = templateCodeInput.trim();
      // if (trimmedTemplateName === "") {
      //   setLoading(false);
      //   toast.error("Please enter a template name.");
      //   return;
      // }

      // Construct the request body for the update API
      const requestBody = {
        asset_name: trimmedTemplateName,
        asset_code: trimmedTemplateCode,
        structure: elementsJSON,
      };

      const apiUrl = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/asset/update/${asset_id}`;
      const response = await fetchWrapper(
        apiUrl,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        },
        navigate
      );

      setLoading(false);

      // if (!response.ok) {
      //   throw new Error("Error saving template");
      // }

      // const data = await response.json();
      navigate("/asset_list"); // Navigate to asset list page after successful save
      setTimeout(() => {
      toast.success("Asset Class updated successfully");
      }, 100);
    } catch (error) {
      console.error("Error:", error);
      setErrors(error.response?.errors || {});
      toast.error(error.message);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchNodes();
    fetchAttributes();
    // fetchSelectedAttributes();
    // fetchAddedAssetMaster()
  }, [template_type_id, asset_id]);

  useEffect(() => {
    if (reactFlowInstance) {

    }
  }, [reactFlowInstance]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const apiUrl = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/asset/${asset_id}`;
        const response = await fetchWrapper(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        });

        // if (!response.ok) {
        //   throw new Error("Failed to fetch asset data");
        // }

        // const data = await response.json();


        setTemplateName(response.asset_name);
        setTemplateNameInput(response.asset_name);

        setTemplateCodeInput(response.asset_code);

        // Parse the structure JSON string
        let structure;
        try {
          structure = JSON.parse(response.structure);
        } catch (error) {
          console.error("Error parsing structure JSON:", error);
          return;
        }

        // Validate the structure
        const nodesArray = structure.find((item) => item.nodes)?.nodes;
        const edgesArray = structure.find((item) => item.edges)?.edges;

        if (!Array.isArray(nodesArray)) {
          console.error(
            "Nodes array is missing or is not an array:",
            nodesArray
          );
          return;
        }

        if (!Array.isArray(edgesArray)) {
          console.error(
            "Edges array is missing or is not an array:",
            edgesArray
          );
          return;
        }

        const iNodes = [];
        const iEdges = [];

        const getTemplateTypeId = (master, templateId) => {
          for (const templateGroup of master) {
            const template = templateGroup.templates.find(
              (template) => template._id === templateId
            );
            if (template) {
              return template.template_type_id;
            }
          }
          return null; // return null if the template is not found
        };

        // Convert nodes
        nodesArray.forEach((node) => {
          iNodes.push({
            id: node.id,
            type: node.type || "defaultNode",
            position: {
              x: parseFloat(node.position.x),
              y: parseFloat(node.position.y),
            },
            data: { label: node.data.label },
            sourcePosition: node.sourcePosition,
            targetPosition: node.targetPosition,
            style: { ...node.style } || { height: 20, width: 100 },
          });

          const templateTypeId = getTemplateTypeId(master, node.id);

          if (templateTypeId) {
            setUsedTemplateTypeIds((prev) => [...prev, templateTypeId]); // Add the template type ID to the used list
          }
        });

        edgesArray.forEach((edge) => {
          // Replace arrow (->) with hyphen (-) in edge.id
          const edgeId = edge.id.replace("->", "-");

          // Push the edge object with the modified id format
          iEdges.push({
            id: `reactflow__edge-${edgeId}`, // Modified id format
            source: edge.source,
            target: edge.target,
            animated: edge.animated || false,
            label: edge.label || "",
            markerEnd: { ...edge.markerEnd },
            type: edge.type,
            sourceHandle: edge.sourceHandle, // Include the source Handle
            targetHandle: edge.targetHandle, // Include the target handle
          });
        });

        // Log and set the elements

        setNodes(iNodes);
        setEdges(iEdges);
      } catch (error) {
        toast.error("Error fetching structure:", error);
      }
    };

    fetchData();
  }, [asset_id, master]);

  useEffect(() => {
    setNodes((nds) => {
      return nds.map((node) => {
        if (node.id === "initial-node") {
          return {
            ...node,
            data: {
              ...node.data,
              label:
                templateNameInput.length > 20
                  ? `${templateNameInput.substring(0, 20)}...`
                  : templateNameInput,
            },
          };
        } else {
          return node; // Return unchanged for other nodes
        }
      });
    });
  }, [templateNameInput]);

  {
    /*** checkbox handlers for select attributes */
  }
  // const handleHeaderCheckboxChange = () => {
  //   const newCheckedStatus = !allChecked;
  //   setAllChecked(newCheckedStatus);
  //   if (newCheckedStatus) {
  //     setCheckedItems(attributes.map((attribute) => attribute._id));
  //   } else {
  //     setCheckedItems([]);
  //   }
  // };
  const handleOrderChange = (id, newOrder) => {
    setAttributes((prevAttributes) =>
      prevAttributes.map((attribute) =>
        attribute._id === id
          ? { ...attribute, order: Number(newOrder) }
          : attribute
      )
    );
  };

  // Handle individual row checkbox change
  const handleRowCheckboxChange = (attributeId) => {
    setCheckedItems((prevCheckedItems) => {
      const isChecked = prevCheckedItems.includes(attributeId);
      const updatedCheckedItems = isChecked
        ? prevCheckedItems.filter((id) => id !== attributeId)
        : [...prevCheckedItems, attributeId];

      // Update order for checked attributes
      setAttributes((prevAttributes) =>
        prevAttributes.map((attribute) => {
          if (updatedCheckedItems.includes(attribute._id)) {
            // If the item is checked, assign an order based on its index
            const order = updatedCheckedItems.indexOf(attribute._id) + 1;
            return { ...attribute, order };
          } else {
            // If unchecked, reset the order to empty
            return { ...attribute, order: "" };
          }
        })
      );

      setAllChecked(updatedCheckedItems.length === attributes.length);
      return updatedCheckedItems;
    });
  };

  // Handle select all checkbox change
  const handleHeaderCheckboxChange = () => {
    const newCheckedStatus = !allChecked;
    if (newCheckedStatus) {
      const allIds = attributes.map((attribute) => attribute._id);
      setCheckedItems(allIds);

      // Update all attributes' order when all are selected
      setAttributes((prevAttributes) =>
        prevAttributes.map((attribute, index) => ({
          ...attribute,
          order: index + 1, // Assign order based on index
        }))
      );
    } else {
      setCheckedItems([]);

      // Reset order to empty when deselecting all
      setAttributes((prevAttributes) =>
        prevAttributes.map((attribute) => ({
          ...attribute,
          order: "", // Reset the order
        }))
      );
    }
    setAllChecked(newCheckedStatus);
  };

  {
    /*** checkbox handlers for select attributes */
  }
  // const handleRowCheckboxChange = (attributeId) => {
  //   setCheckedItems((prevCheckedItems) => {
  //     const isChecked = prevCheckedItems.includes(attributeId);
  //     const updatedCheckedItems = isChecked
  //       ? prevCheckedItems.filter((id) => id !== attributeId)
  //       : [...prevCheckedItems, attributeId];

  //     setAllChecked(updatedCheckedItems.length === attributes.length);
  //     return updatedCheckedItems;
  //   });
  // };

  const handleSelectedAttributes = async (e) => {
    e.preventDefault();
    setLoading(true);
    const apiUrl = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/asset-class-attribute/create`;

    const requestBody = {
      asset_id: asset_id,
      asset_attribute_ids: attributes
        .filter((attr) => checkedItems.includes(attr._id))
        .map((attr) => ({
          id: attr._id,
          order: attr.order ? Number(attr.order) : 1, // Default order to 1 if not specified
        })),
    };



    try {
      const response = await fetchWrapper(
        apiUrl,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        },
        navigate
      );


      toast.success("SelectedAttributes saved successfully");
      setLoading(false);
      closeAttributeModal();
    } catch (error) {
      console.error("SelectedAttributes saving error:", error);
      toast.error("Error saving selected attributes");
      setLoading(false);

      if (error.response && error.response.status === 401) {
        navigate("/auth/login");
      }
    }
  };

  // const handleMasterHeaderCheckbox = (masterName) => {
  //   const groupIndex = templateMasters.findIndex(
  //     (group) => group.master_name === masterName
  //   );

  //   // Check if groupIndex is valid
  //   if (groupIndex === -1) {
  //     console.error(`Group with master_name "${masterName}" not found.`);
  //     return;
  //   }

  //   // Check if the group at groupIndex has templates
  //   if (
  //     !templateMasters[groupIndex] ||
  //     !templateMasters[groupIndex].templates
  //   ) {
  //     console.error(
  //       `Templates for group with master_name "${masterName}" are undefined.`
  //     );
  //     return;
  //   }

  //   const allChecked = templateMasters[groupIndex].templates.every(
  //     (templateMaster) =>
  //       checkedTemplateMasters.some(
  //         (item) => item.template_master_id === templateMaster._id
  //       )
  //   );

  //   let updatedCheckedTemplateMasters;

  //   if (allChecked) {
  //     // Uncheck all
  //     updatedCheckedTemplateMasters = checkedTemplateMasters.filter(
  //       (item) =>
  //         !templateMasters[groupIndex].templates.some(
  //           (template) => template._id === item.template_master_id
  //         )
  //     );
  //   } else {
  //     // Check all
  //     const newCheckedTemplates = templateMasters[groupIndex].templates.map(
  //       (templateMaster) => ({
  //         template_master_id: templateMaster._id,
  //         document_code: templateMaster.document_code,
  //       })
  //     );

  //     updatedCheckedTemplateMasters = [
  //       ...checkedTemplateMasters,
  //       ...newCheckedTemplates.filter(
  //         (templateMaster) =>
  //           !checkedTemplateMasters.some(
  //             (item) =>
  //               item.template_master_id === templateMaster.template_master_id
  //           )
  //       ),
  //     ];
  //   }

  //   setCheckedTemplateMasters(updatedCheckedTemplateMasters);
  // };
  const handleMasterHeaderCheckbox = (masterName) => {
    const groupIndex = templateMasters.findIndex(
      (group) => group.master_name === masterName
    );

    // Check if groupIndex is valid
    if (groupIndex === -1) {
      console.error(`Group with master_name "${masterName}" not found.`);
      return;
    }

    // Get the filtered templates for the current group based on the search query
    const filteredTemplates =
      filteredTemplateMasters.find((group) => group.master_name === masterName)
        ?.templates || [];

    // Check if the filteredTemplates array is empty
    if (filteredTemplates.length === 0) {
      console.error(
        `No filtered templates found for master_name "${masterName}".`
      );
      return;
    }

    // Check if all filtered templates are checked
    const allChecked = filteredTemplates.every((templateMaster) =>
      checkedTemplateMasters.some(
        (item) => item.template_master_id === templateMaster._id
      )
    );

    let updatedCheckedTemplateMasters;

    if (allChecked) {
      // Uncheck all filtered templates
      updatedCheckedTemplateMasters = checkedTemplateMasters.filter(
        (item) =>
          !filteredTemplates.some(
            (template) => template._id === item.template_master_id
          )
      );
    } else {
      // Check all filtered templates
      const newCheckedTemplates = filteredTemplates.map((templateMaster) => ({
        template_master_id: templateMaster._id,
        document_code: templateMaster.document_code,
      }));

      updatedCheckedTemplateMasters = [
        ...checkedTemplateMasters,
        ...newCheckedTemplates.filter(
          (templateMaster) =>
            !checkedTemplateMasters.some(
              (item) =>
                item.template_master_id === templateMaster.template_master_id
            )
        ),
      ];
    }

    setCheckedTemplateMasters(updatedCheckedTemplateMasters);
  };

  {
    /*** checkbox handlers for select template masters */
  }
  const handleMasterRowCheckbox = (templateMasterId, templateMasterCode) => {
    setCheckedTemplateMasters((prevCheckedItems) => {
      const isChecked = prevCheckedItems.some(
        (item) => item.template_master_id === templateMasterId
      );

      const updatedCheckedItems = isChecked
        ? prevCheckedItems.filter(
          (item) => item.template_master_id !== templateMasterId
        )
        : [
          ...prevCheckedItems,
          {
            template_master_id: templateMasterId,
            document_code: templateMasterCode,
          },
        ];

      // setAllCheckedMasters(
      //   updatedCheckedItems.length === templateMasters.length
      // );
      return updatedCheckedItems;
    });
  };

  const handleUniqueCheckbox = (masterName) => {
    setUniqueCheckboxes((prev) => ({
      ...prev,
      [masterName]: !prev[masterName],
    }));
  };

  const handleAddAssetMaster = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const templateId = selectedNode.id;
      const apiUrl = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/asset-master/create`;
      const mappedData = checkedTemplateMasters.map((item) => {
        const hasConnected = item.document_code.includes('-');
        const groupName = filteredTemplateMasters.find(group =>
          group.templates.some(template => template._id === item.template_master_id)
        )?.master_name;
        return {
          template_master_id: item.template_master_id,
          document_code: item.document_code,
          nodes: [],
          ...(hasConnected && uniqueCheckboxes[groupName] ? { unique: true } : {}),
        };
      });
      const response = await fetchWrapper(
        apiUrl,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            asset_id: asset_id,
            template_id: templateId,
            data: mappedData,
          }),
        },
        navigate
      );
      toast.success("Asset Masters added successfully");
      closeTemplateModal();
      setLoading(false);
      setTableSearchQueries("");
    } catch (error) {
      console.error("Error adding Asset Masters:", error);
      toast.error("Error adding Asset Masters");
      setLoading(false);
      if (error.response && error.response.status === 401) {
        navigate("/auth/login");
      }
    }
  };


  // const handleAddAssetMaster = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);

  //   try {
  //     const templateId = selectedNode.id;
  //     const apiUrl = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/asset-master/create`;

  //     const mappedData = checkedTemplateMasters.map((item) => ({
  //       template_master_id: item.template_master_id,
  //       document_code: item.document_code,
  //       nodes: [], // Adjust as needed based on your data structure
  //     }));

  //     const response = await fetchWrapper(
  //       apiUrl,
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify({
  //           asset_id: asset_id,
  //           template_id: templateId,
  //           data: mappedData,
  //         }),
  //       },
  //       navigate
  //     ); // Pass navigate for redirection

  //     // if (!response.ok) {
  //     //   throw new Error("Asset Masters adding failed");
  //     // }

  //     toast.success("Asset Masters added successfully");
  //     closeTemplateModal();
  //     setLoading(false);
  //     setTableSearchQueries("");
  //   } catch (error) {
  //     console.error("Error adding Asset Masters:", error);
  //     toast.error("Error adding Asset Masters");

  //     setLoading(false);

  //     // Optionally handle navigation on specific error conditions
  //     if (error.response && error.response.status === 401) {
  //       navigate("/auth/login");
  //     }
  //   }
  // };
  const handleAddTemplateAttribute = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});

    try {
      const templateId = selectedNode.id;

      // Prepare the field_value as an array if it contains commas
      const formattedFieldValue = newTemplateAttribute.field_value.includes(",")
        ? newTemplateAttribute.field_value.split(",").map((item) => item.trim())
        : newTemplateAttribute.field_value;

      // Construct the new asset attribute data
      const newAttributeData = {
        asset_id: `${asset_id}`,
        template_id: templateId,
        field_name: newTemplateAttribute.field_name,
        field_type: newTemplateAttribute.field_type,
        field_value: formattedFieldValue,
        display_name: newTemplateAttribute.display_name,
        required: newTemplateAttribute.required,
        parameter_type_id: newTemplateAttribute.parameter_type_id, // ✅ Add this
        master_id: newTemplateAttribute.master_id,
      };

      // Send the POST request to create the new template attribute using fetchWrapper
      const response = await fetchWrapper(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/template-attribute/create`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(newAttributeData),
        },
        navigate // Pass navigate for redirection
      );

      // if (!response.ok) {
      //   const errorMessaged = response.message;
      //   setErrors(response.errors || {});
      //   toast.error(errorMessaged);
      //   setLoading(false);
      //   return;
      // }

      // const data = await response.json();

      // Close the modal after successful addition

      setIsModalOpen(false);
      toast.success("Asset attribute added successfully");

      // Reset new template attribute state
      setNewTemplateAttribute({
        asset_id: "",
        template_id: "",
        field_name: "",
        field_type: "",
        field_value: "",
        display_name: "",
        required: false,
        master_id: "",
        parameter_type_id: "",
      });
    } catch (error) {
      console.error("Error adding asset attribute:", error);
      toast.error("Error adding asset attribute");
      if (error.response) {
        const errorData = error.response;
        console.error(errorData);
        setErrors(errorData.errors || {});
        toast.error(errorData.message || "Error adding role");
      } else {
        console.error("Error adding role:", error);
        toast.error("Error adding role");
      }
    } finally {
      setLoading(false);
    }
  };

 const openEditModal = async (editElementId) => {
  setLoading(true);
  setEditElementId(editElementId);

  try {
    const response = await fetchWrapper(
      `${process.env.REACT_APP_BASE_API_URL1}/api/v1/template-attribute/update/${editElementId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      },
      navigate
    );

    // The actual attribute data is inside response.after
    const data = response.after;

    setEditTemplateAttribute({
      field_name: data.field_name,
      field_type: data.field_type,
      field_value: Array.isArray(data.field_value)
        ? data.field_value.join(", ")
        : data.field_value,
      display_name: data.display_name,
      required: data.required,
      master_id: data?.master_id,
      parameter_type_id: data?.parameter_type_id,
    });

    setEditSpecializationName(data.field_name);
    setIsEditModalOpen(true);
    setLoading(false);
  } catch (error) {
    console.error("Error fetching data for editing:", error);
    setLoading(false);
  }
};

  const updateSpecification = async (e) => {
    setLoading(true);
    e.preventDefault();
    setLoading(true);
    setErrors({});
    try {
      const templateId = selectedNode.id;

      // Prepare the field_value as an array if it contains commas
      const formattedFieldValue = editTemplateAttribute.field_value.includes(
        ","
      )
        ? editTemplateAttribute.field_value
          .split(",")
          .map((item) => item.trim())
        : editTemplateAttribute.field_value;

      // Construct the new asset attribute data
      const editAttributeData = {
        asset_id: `${asset_id}`,
        template_id: templateId,
        field_name: editTemplateAttribute.field_name,
        field_type: editTemplateAttribute.field_type,
        field_value: formattedFieldValue,
        display_name: editTemplateAttribute.display_name,
        required: editTemplateAttribute.required,
        master_id: editTemplateAttribute?.master_id,
        parameter_type_id: editTemplateAttribute?.parameter_type_id
      };

      // Send the POST request to update the template attribute
      const response = await fetchWrapper(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/template-attribute/update/${editElementId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(editAttributeData),
        },
        navigate // Pass navigate for redirection
      );

      // Clear the form fields and reset state
      setEditTemplateAttribute({
        asset_id: "",
        template_id: "",
        field_name: "",
        field_type: "",
        field_value: "",
        display_name: "",
        required: false,
        master_id: "",
        parameter_type_id: "",
      });
      setLoading(false);
      setEditElementId("");
      setEditSpecializationName("");
      closeEditModal();
      fetchTemplateAttributes();
      toast.success("Specification updated successfully");
    } catch (error) {
      console.error("Error updating specification:", error);

      // Extract and display error messages

      const errorMessage =
        error.response?.data?.message || "Error updating specification";
      const errorDetails = error.response?.data?.errors || {};

      toast.error(errorMessage);
      setErrors(errorDetails);

      // Log the detailed errors if available
      if (errorDetails) {
        console.error("Detailed errors:", errorDetails);
      }
    } finally {
      setLoading(false);
    }
  };

  // const deleteSpecialization = async (deleteElementId, deleteElementName) => {
  //   setEditElementId(deleteElementId)
  //   setEditSpecializationName(deleteElementName)
  //   setConfirmModal(true);
  // }

  const confirmAction = async () => {
    setLoading(true);
    const url = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/template-attribute/delete/${editElementId}`;

    try {
      await fetchWrapper(
        url,
        {
          method: "POST",
        },
        navigate // Pass navigate function for redirection
      );

      setEditElementId("");
      setEditSpecializationName("");
      fetchTemplateAttributes(); // Assuming fetchTemplateAttributes is a function to update attributes
      setLoading(false);
      setConfirmModal(false);
      toast.success("Specification deleted successfully");
    } catch (error) {
      setLoading(false);
      console.error("Error deleting specification:", error);
      toast.error("Error deleting specification");

      // Optionally handle navigation on specific error conditions
      if (error.response && error.response.status === 401) {
        navigate("/auth/login");
      }
    }
  };

  useEffect(() => {
    if (shouldFetch && selectedNode) {
      fetchTemplateMasters();
      fetchAddedAssetMaster();
      setShouldFetch(false); // Reset the trigger
    }
  }, [shouldFetch, selectedNode]);

  useEffect(() => {
    const errorHandler = (e) => {
      if (
        e.message.includes(
          "ResizeObserver loop completed with undelivered notifications" ||
          "ResizeObserver loop limit exceeded"
        )
      ) {
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.style.display = "none";
        }
      }
    };
    window.addEventListener("error", errorHandler);

    return () => {
      window.removeEventListener("error", errorHandler);
    };
  }, []);

  useEffect(() => {
    if (isTemplateModalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isTemplateModalOpen]);

  const handleClick = async (e) => {
    e.preventDefault();
    setIsModalconfigOpen(true);
    setRowLimit1("");
    setorder1("");

    try {
      const template_id = templateId;
      const asset_id1 = asset_id;

      const url = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/asset-configuration/${asset_id1}/${template_id}`;

      const response = await fetchWrapper(
        url,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        },
        navigate
      );

      setorder1(response.order);
      setRowLimit1(response.row_limit);

      // Show success toast notification

      // Clear selections
    } catch (error) {
      console.error("Error saving data:", error.message);
    }
  };

  const submitDataToAPI = async (e) => {
    setLoading(true);
    e.preventDefault();
    const template_id = templateId;
    const asset_id1 = asset_id;
    // const assetId = asset_id;

    try {
      // Find the default field

      // The payload for the POST request
      const payload = {
        template_id: template_id,
        asset_id: asset_id1,
        order: order1,
        row_limit: row_limit1,
      };

      const url = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/asset-configuration/upsert`;

      const response = await fetchWrapper(
        url,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
        navigate
      );

      // Show success toast notification
      toast.success("Data saved successfully");
      setLoading(false);

      // Clear selections
    } catch (error) {
      console.error("Error saving data:", error.message);
      toast.error(error.message);
    } finally {
      setIsModalconfigOpen();
      setLoading(false);
    }
  };

  useEffect(() => {
    const newFilteredTemplateMasters = templateMasters.map((group) => {
      const searchQuery =
        tableSearchQueries[group.master_name]?.toLowerCase() || "";
      return {
        ...group,
        templates: group.templates.filter((templateMaster) =>
          templateMaster.document_code.toLowerCase().includes(searchQuery)
        ),
      };
    });
    setFilteredTemplateMasters(newFilteredTemplateMasters);
  }, [tableSearchQueries, templateMasters]);

  const handleTableSearch = (e, masterName) => {
    setTableSearchQueries({
      ...tableSearchQueries,
      [masterName]: e.target.value,
    });
  };



  useEffect(() => {
    fetchParameterTypes();
  }, [])

  const fetchParameterTypes = async () => {
    try {
      const data = await fetchWrapper(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/parameter-type/getall`,
        {
          method: "POST",
        }
      );
      // Update the parameters state with the fetched data
      setParameters(data);
      return data; // Return the fetched data
    } catch (error) {
      console.error("Error fetching parameter types:", error);
      throw error; // Re-throw the error to handle it in the calling code
    }
  };
  useEffect(() => {
    fetchParameterTypes();
  }, [])

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div>
          <div className="tb-responsive templatebuilder-body">
            <div className="tb-container pt-3">
              <nav
                className="breadcrumb-nav show-breadcrumb"
                aria-label="breadcrumb"
              >
                <h5>Update Asset Class</h5>
                <ol className="breadcrumb template-breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#" style={{ pointerEvents: "none" }}>
                      Assets
                    </a>
                  </li>

                  <li className="breadcrumb-item">
                    <a href="" style={{ pointerEvents: "none" }}>
                      Asset Class
                    </a>
                  </li>

                  <li className="breadcrumb-item">
                    <a href="" style={{ pointerEvents: "none" }}>
                      {templateName ? templateName : "Loading..."}
                    </a>
                  </li>

                  <li className="breadcrumb-item active" aria-current="page">
                    Update
                  </li>
                </ol>
              </nav>

              <div
                style={{ marginRight: 0, marginLeft: 0 }}
                className="row tb-header align-content-center "
              >
                <div className="col-md-3" style={{ width: "300px" }}>
                  <div className="tb-search-div">
                    <img
                      src={search1}
                      className="tg-search-icon"
                      alt="search icon"
                    />
                    <input
                      className="tb-search-input"
                      placeholder="search"
                      style={{ padding: "8px 35px" }}
                      value={searchQuery}
                      onChange={handleSearchChange}
                    />
                  </div>
                </div>

                <div className="col text-center">
                  <div className="d-flex justify-content-between align-content-center">
                    <h6 className="align-content-center">Asset Builder</h6>
                    <div className="d-flex gap-3">
                      <div className="tb-search-div d-flex gap-3">
                        <img
                          src={folder}
                          className="tg-search-icon"
                          alt="folder icon"
                        />
                        <input
                          className={`form-control ${errors.asset_code ? "is-invalid" : ""
                            }`}
                          placeholder="Asset Code"
                          style={{ padding: "8px 35px", width: "350px" }}
                          value={templateCodeInput}
                          onChange={(e) => setTemplateCodeInput(e.target.value)}
                          ref={templateCodeRef}
                        />
                      </div>
                      <div className="tb-search-div d-flex gap-3">
                        <img
                          src={folder}
                          className="tg-search-icon"
                          alt="folder icon"
                        />
                        <input
                          className={`form-control ${errors.asset_name ? "is-invalid" : ""
                            }`}
                          placeholder="Asset Name"
                          style={{ padding: "8px 35px", width: "350px" }}
                          value={templateNameInput}
                          onChange={(e) => setTemplateNameInput(e.target.value)}
                          ref={templateNameRef}
                        />
                        <button onClick={() => setConfirm(true)} className="tb-save-btn">
                          SAVE
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="dndflow " onClick={hideButton}>
                <Sidebar
                  master={master}
                  usedTemplateTypeIds={usedTemplateTypeIds}
                  searchQuery={searchQuery}
                />

                <ReactFlowProvider>
                  <div
                    className="reactflow-wrapper"
                    ref={reactFlowWrapper}
                    style={{ height: 600 }}
                  >
                    <ReactFlow
                      nodes={nodes}
                      edges={edges}
                      nodeTypes={nodeTypes}
                      edgeTypes={edgeTypes}
                      onNodesChange={onNodesChange}
                      onEdgesChange={onEdgesChange}
                      onConnect={onConnect}
                      onInit={setReactFlowInstance}
                      onDrop={onDrop}
                      onDragOver={onDragOver}
                      onNodeDoubleClick={onNodeDoubleClick}
                      onNodeContextMenu={onNodeContextMenu}
                      onEdgeClick={onEdgeClick}
                      onLoad={(reactFlowInstance) =>
                        reactFlowInstance.fitView()
                      }
                      fitView
                    >
                      <Controls />
                      <SmoothStepEdge type="smoothstep" />
                      {/* Display delete button when edgeToDelete is set */}
                      {edgeToDelete && (
                        <div
                          className="edit-cont"
                          style={{
                            cursor: "pointer",
                            position: "absolute",
                            left: edgeToDelete.position.x, // Correct position
                            top: edgeToDelete.position.y, // Correct position
                            zIndex: 10,
                          }}
                        >
                          <button
                            className="edit-btn"
                            onClick={() => openEdgeLabelModal(edgeToDelete.id)}
                          >
                            Add Label
                          </button>
                          <button
                            className="delete-btn"
                            onClick={(e) => {
                              e.stopPropagation(); // Ensure only this click is registered
                              onDeleteEdge(); // Trigger edge deletion
                            }}
                          >
                            Delete Edge
                          </button>
                        </div>
                      )}
                      <Background
                        id="1"
                        gap={10}
                        color="#e8e8e8"
                        variant={BackgroundVariant.Lines}
                      />
                    </ReactFlow>
                  </div>
                </ReactFlowProvider>

                {contextMenu.isOpen && (
                  <div
                    className="edit-cont"
                    style={{
                      position: "absolute",
                      top: contextMenu.position.y,
                      left: contextMenu.position.x,
                    }}
                    onClick={closeContextMenu}
                  >
                    <button
                      className="edit-btn"
                      // onClick={() => setIsModalconfigOpen(true)}
                      onClick={handleClick}
                    >
                      Configuration
                    </button>
                    <button
                      className="edit-btn"
                      onClick={() => setIsModalOpen(true)}
                    >
                      Add Specification
                    </button>
                    <button
                      className="edit-btn"
                      onClick={() => {
                        fetchTemplateAttributes();
                        setIsViewModalOpen(true);
                      }}
                    >
                      View Specification
                    </button>
                    <button
                      className="delete-btn"
                      onClick={() => onDeleteNode(selectedNode)}
                    >
                      Delete Node
                    </button>{" "}
                    {/* Use onDeleteNode */}
                  </div>
                )}

                {/* Modal for add Specialization*/}
                <div
                  id="overlay"
                  className={`modal fade ${isModalOpen ? "show" : ""}`}
                  tabIndex="-1"
                  role="dialog"
                  style={{
                    zIndex: 30,
                    display: isModalOpen ? "block" : "none",
                    transition: "width 2s",
                  }}
                >
                  <div>
                    <div
                      className="addunit-card Width 25%"
                      style={{ maxHeight: "500px" }}
                    >
                      <div className="addunit-header">
                        <h4>
                          {selectedNode && selectedNode.data.label
                            ? selectedNode.data.label
                            : "Loading"}
                        </h4>
                        <button
                          style={{ border: "none", backgroundColor: "inherit" }}
                          type="button"
                          className="close"
                          onClick={closeModal}
                        >
                          <img
                            src={close}
                            width="28px"
                            height="28px"
                            alt="Close"
                          />
                        </button>
                      </div>

                      <form
                        onSubmit={handleAddTemplateAttribute}
                        autoComplete="off"
                        noValidate
                        className="needs-validation"
                      >
                        {/* <div className="addunit-form">
                          <div className="row mb-4">
                            <div className="col">
                              <div className="d-flex flex-column ">
                                <label
                                  htmlFor="fieldName"
                                  className="addunit-form-text"
                                >
                                  Field Name{" "}
                                  <span className="text-danger"> *</span>
                                </label>
                                <input
                                  type="text"
                                  className={`form-control ${errors.field_name ? "is-invalid" : ""
                                    }`}
                                  id="fieldName"
                                  placeholder="Enter the Field Name"
                                  value={newTemplateAttribute.field_name}
                                  onChange={(e) =>
                                    setNewTemplateAttribute({
                                      ...newTemplateAttribute,
                                      field_name: e.target.value,
                                    })
                                  }
                                />
                                {errors.field_name && (
                                  <div className="invalid-feedback">
                                    {errors.field_name}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="col">
                              <div className="d-flex flex-column ">
                                <label
                                  htmlFor="fieldType"
                                  className="addunit-form-text"
                                >
                                  Field Type{" "}
                                  <span className="text-danger"> *</span>
                                </label>
                                <select
                                  className={`form-select select-unit textarea ${errors.field_type ? "is-invalid" : ""
                                    }`}
                                  id="fieldType"
                                  value={newTemplateAttribute.field_type}
                                  onChange={(e) =>
                                    setNewTemplateAttribute({
                                      ...newTemplateAttribute,
                                      field_type: e.target.value,
                                    })
                                  }
                                >
                                  <option disabled value="">
                                    Select
                                  </option>
                                  <option value="string">String</option>
                                  <option value="number">Number</option>
                                  <option value="select">Select</option>
                                  <option value="date">Date</option>
                                  <option value="textarea">Textarea</option>
                                  <option value="file">File</option>

                                </select>
                                {errors.field_type && (
                                  <div
                                    className="invalid-feedback"
                                    style={{ color: "red" }}
                                  >
                                    {errors.field_type}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-6">
                              <div className="d-flex flex-column mb-4">
                                <label
                                  htmlFor="fieldValue"
                                  className="addunit-form-text"
                                >
                                  Field Value
                                </label>
                                <input
                                  type="text"
                                  className={`form-control ${errors.field_value ? "is-invalid" : ""
                                    }`}
                                  id="fieldValue"
                                  placeholder="Enter the Field Value"
                                  value={newTemplateAttribute.field_value}
                                  onChange={(e) =>
                                    setNewTemplateAttribute({
                                      ...newTemplateAttribute,
                                      field_value: e.target.value,
                                    })
                                  }
                                  disabled={
                                    newTemplateAttribute.field_type !== "select"
                                  }
                                />
                                {errors.field_value && (
                                  <div className="invalid-feedback">
                                    {errors.field_value}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="col-6 ">
                              <div className="d-flex flex-column mb-4">
                                <label
                                  htmlFor="displayName"
                                  className="addunit-form-text"
                                >
                                  Display Name{" "}
                                  <span className="text-danger"> *</span>
                                </label>
                                <input
                                  type="text"
                                  className={`form-control ${errors.display_name ? "is-invalid" : ""
                                    }`}
                                  id="displayName"
                                  placeholder="Enter the Display Name"
                                  value={newTemplateAttribute.display_name}
                                  onChange={(e) =>
                                    setNewTemplateAttribute({
                                      ...newTemplateAttribute,
                                      display_name: e.target.value,
                                    })
                                  }
                                />
                                {errors.display_name && (
                                  <div className="invalid-feedback">
                                    {errors.display_name}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="d-flex flex-column mb-4">
                              <label
                                htmlFor="required"
                                className="addunit-form-text"
                              >
                                Required <span className="text-danger"> *</span>
                              </label>
                              <select
                                className={`form-select select-unit textarea ${errors.required ? "is-invalid" : ""
                                  }`}
                                id="required"
                                value={newTemplateAttribute.required}
                                onChange={(e) =>
                                  setNewTemplateAttribute({
                                    ...newTemplateAttribute,
                                    required: e.target.value,
                                  })
                                }
                              >
                                <option disabled value="">
                                  Select
                                </option>
                                <option value="true">Yes</option>
                                <option value="false">No</option>
                              </select>
                            </div>
                          </div>
                        </div> */}
                        <div className="addunit-form">
                          <div className="row mb-4">
                            <div className="col">
                              <div className="d-flex flex-column ">
                                <label
                                  htmlFor="fieldName"
                                  className="addunit-form-text"
                                >
                                  Field Name{" "}
                                  <span className="text-danger"> *</span>
                                </label>
                                <input
                                  type="text"
                                  className={`form-control ${errors.field_name ? "is-invalid" : ""
                                    }`}
                                  id="fieldName"
                                  placeholder="Enter the Field Name"
                                  value={newTemplateAttribute.field_name}
                                  onChange={(e) =>
                                    setNewTemplateAttribute({
                                      ...newTemplateAttribute,
                                      field_name: e.target.value,
                                    })
                                  }
                                />
                                {errors.field_name && (
                                  <div className="invalid-feedback">
                                    {errors.field_name}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="col">
                              <div className="d-flex flex-column ">
                                <label
                                  htmlFor="fieldType"
                                  className="addunit-form-text"
                                >
                                  Field Type{" "}
                                  <span className="text-danger"> *</span>
                                </label>
                                <select
                                  className={`form-select select-unit textarea ${errors.field_type ? "is-invalid" : ""
                                    }`}
                                  id="fieldType"
                                  value={newTemplateAttribute.field_type}
                                  onChange={(e) =>
                                    setNewTemplateAttribute({
                                      ...newTemplateAttribute,
                                      field_type: e.target.value,
                                    })
                                  }
                                >
                                  <option disabled value="">
                                    Select
                                  </option>
                                  <option value="string">String</option>
                                  <option value="number">Number</option>
                                  <option value="select">Select</option>
                                  <option value="date">Date</option>
                                  <option value="textarea">Textarea</option>
                                  {/* <option value="file">File</option> */}
                                  <option value="list">List</option>
                                </select>
                                {errors.field_type && (
                                  <div
                                    className="invalid-feedback"
                                    style={{ color: "red" }}
                                  >
                                    {errors.field_type}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          {newTemplateAttribute.field_type === "list" && (
                            <div className="row">
                              <div className="col-6">
                                <div className="d-flex flex-column mb-4">
                                  <label htmlFor="parameterType" className="addunit-form-text">
                                    Select Parameter Type <span className="text-danger">*</span>
                                  </label>
                                  <select
                                    className="form-select"
                                    id="parameterType"
                                    value={newTemplateAttribute.parameter_type_id || ""}
                                    onChange={(e) => {
                                      const selectedId = e.target.value;
                                      const selectedParam = parameters.find((p) => p._id === selectedId);

                                      setNewTemplateAttribute({
                                        ...newTemplateAttribute,
                                        parameter_type_id: selectedId,
                                        master_id: "", // reset previously selected master
                                      });

                                      setSelectedMasters(selectedParam?.masterDetails || []);
                                    }}
                                  >
                                    <option disabled value="">Select Parameter Type</option>
                                    {parameters.map((param) => (
                                      <option key={param._id} value={param._id}>
                                        {param.parameter_type_name}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                            </div>
                          )}

                          {selectedMasters.length > 0 && newTemplateAttribute.field_type === "list" && (
                            <div className="row">
                              <div className="col-6">
                                <div className="d-flex flex-column mb-4">
                                  <label htmlFor="masterDropdown" className="addunit-form-text">
                                    Select Master <span className="text-danger">*</span>
                                  </label>
                                  {/* <select
                                    className="form-select"
                                    id="masterDropdown"
                                    value={newTemplateAttribute.master_id || ""}
                                    onChange={(e) =>
                                      setNewTemplateAttribute({
                                        ...newTemplateAttribute,
                                        master_id: e.target.value,
                                      })
                                    }
                                  >
                                    <option disabled value="">Select Master</option>
                                    {selectedMasters.map((master) => (
                                      <option key={master.masterId} value={master.masterId}>
                                        {master.masterName}
                                      </option>
                                    ))}
                                  </select> */}
                                  <select
                                    className="form-select"
                                    id="masterDropdown"
                                    value={newTemplateAttribute.master_id || ""}
                                    onChange={async (e) => {
                                      const selectedMasterId = e.target.value;

                                      // Fetch the values from backend
                                      const masterValues = await fetchMasterValues(selectedMasterId); // API call

                                      // Extract only the relevant values (e.g., unit_name or unit_code)
                                      const valueList = masterValues.map((item) => {
                                        const firstKey = Object.keys(item).find(k =>
                                          !["id", "_v", "status", "deleted_at", "created_at", "updated_at"].includes(k)
                                        );
                                        return item[firstKey];
                                      });

                                      // Join them with commas
                                      const commaSeparatedValues = valueList.join(",");

                                      // Update the state
                                      setNewTemplateAttribute((prev) => ({
                                        ...prev,
                                        master_id: selectedMasterId,
                                        // field_value: commaSeparatedValues, // store directly
                                      }));
                                    }}
                                  >
                                    <option disabled value="">Select Master</option>
                                    {selectedMasters.map((master) => (
                                      <option key={master.masterId} value={master.masterId}>
                                        {master.masterName}
                                      </option>
                                    ))}
                                  </select>


                                </div>
                              </div>
                            </div>
                          )}



                          <div className="row">
                            <div className="col-6">
                              <div className="d-flex flex-column mb-4">
                                <label
                                  htmlFor="fieldValue"
                                  className="addunit-form-text"
                                >
                                  Field Value
                                </label>
                                <input
                                  type="text"
                                  className={`form-control ${errors.field_value ? "is-invalid" : ""
                                    }`}
                                  id="fieldValue"
                                  placeholder="Enter the Field Value"
                                  value={newTemplateAttribute.field_value}
                                  onChange={(e) =>
                                    setNewTemplateAttribute({
                                      ...newTemplateAttribute,
                                      field_value: e.target.value,
                                    })
                                  }
                                  disabled={
                                    newTemplateAttribute.field_type !== "select"
                                  }
                                />
                                {errors.field_value && (
                                  <div className="invalid-feedback">
                                    {errors.field_value}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="col-6 ">
                              <div className="d-flex flex-column mb-4">
                                <label
                                  htmlFor="displayName"
                                  className="addunit-form-text"
                                >
                                  Display Name{" "}
                                  <span className="text-danger"> *</span>
                                </label>
                                <input
                                  type="text"
                                  className={`form-control ${errors.display_name ? "is-invalid" : ""
                                    }`}
                                  id="displayName"
                                  placeholder="Enter the Display Name"
                                  value={newTemplateAttribute.display_name}
                                  onChange={(e) =>
                                    setNewTemplateAttribute({
                                      ...newTemplateAttribute,
                                      display_name: e.target.value,
                                    })
                                  }
                                />
                                {errors.display_name && (
                                  <div className="invalid-feedback">
                                    {errors.display_name}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="d-flex flex-column mb-4">
                              <label
                                htmlFor="required"
                                className="addunit-form-text"
                              >
                                Required <span className="text-danger"> *</span>
                              </label>
                              <select
                                className={`form-select select-unit textarea ${errors.required ? "is-invalid" : ""
                                  }`}
                                id="required"
                                value={newTemplateAttribute.required}
                                onChange={(e) =>
                                  setNewTemplateAttribute({
                                    ...newTemplateAttribute,
                                    required: e.target.value,
                                  })
                                }
                              >
                                <option disabled value="">
                                  Select
                                </option>
                                <option value="true">Yes</option>
                                <option value="false">No</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="addunit-card-footer justify-content-between">
                          <button
                            type="button"
                            className="discard-btn"
                            onClick={closeModal}
                          >
                            Close
                          </button>
                          <button type="submit" className="update-btn">
                            Save
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                {/* Modal for add config*/}
                <div
                  id="overlay"
                  className={`modal fade ${isModalconfigOpen ? "show" : ""}`}
                  tabIndex="-1"
                  role="dialog"
                  style={{
                    zIndex: 30,
                    display: isModalconfigOpen ? "block" : "none",
                    transition: "width 2s",
                  }}
                >
                  <div>
                    <div
                      className="addunit-card Width 25%"
                      style={{ maxHeight: "500px" }}
                    >
                      <div className="addunit-header">
                        <h4>Add Configure</h4>
                        <button
                          style={{ border: "none", backgroundColor: "inherit" }}
                          type="button"
                          className="close"
                          onClick={closeModalconfig}
                        >
                          <img
                            src={close}
                            width="28px"
                            height="28px"
                            alt="Close"
                          />
                        </button>
                      </div>

                      <form
                        onSubmit={submitDataToAPI}
                        autoComplete="off"
                        noValidate
                        className="needs-validation"
                      >
                        <div className="addunit-form">
                          <div className="row">
                            <div className="col-6">
                              <div className="d-flex flex-column mb-4">
                                <label
                                  htmlFor="fieldValue"
                                  className="addunit-form-text"
                                >
                                  Order
                                </label>
                                <input
                                  type="number"
                                  className={`form-control ${errors.field_value ? "is-invalid" : ""
                                    }`}
                                  id="fieldValue"
                                  placeholder="Enter the order"
                                  value={order1}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    if (value >= 1 || value === "") {
                                      setorder1(value);
                                    }
                                  }}
                                  min="1"
                                />

                                {errors.field_value && (
                                  <div className="invalid-feedback">
                                    {errors.field_value}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="col-6 ">
                              <div className="d-flex flex-column mb-4">
                                <label
                                  htmlFor="displayName"
                                  className="addunit-form-text"
                                >
                                  Row Limit
                                </label>
                                <input
                                  type="text"
                                  className={`form-control ${errors.display_name ? "is-invalid" : ""
                                    }`}
                                  id="displayName"
                                  placeholder="Enter the Row Limit"
                                  value={row_limit1}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    if (value >= 1 || value === "") {
                                      setRowLimit1(value);
                                    }
                                  }}
                                />
                                {errors.display_name && (
                                  <div className="invalid-feedback">
                                    {errors.display_name}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="addunit-card-footer justify-content-between">
                          <button
                            type="button"
                            className="discard-btn"
                            onClick={closeModalconfig}
                          >
                            Close
                          </button>
                          <button type="submit" className="update-btn">
                            Save
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>

                {/* Modal for view Specializations */}
                <div
                  id="overlay"
                  className={`modal fade ${isViewModalOpen ? "show" : ""}`}
                  tabIndex="-1"
                  role="dialog"
                  style={{
                    zIndex: 30,
                    display: isViewModalOpen ? "block" : "none",
                    transition: "width 2s",
                  }}
                >
                  <div>
                    <div
                      className="addunit-card Width 25%"
                      style={{ maxHeight: "500px" }}
                    >
                      <div className="addunit-header">
                        <h4>
                          {selectedNode && selectedNode.data.label
                            ? selectedNode.data.label
                            : "Loading"}
                        </h4>
                        <button
                          style={{ border: "none", backgroundColor: "inherit" }}
                          type="button"
                          className="close"
                          onClick={closeViewModal}
                        >
                          <img
                            src={close}
                            width="28px"
                            height="28px"
                            alt="Close"
                          />
                        </button>
                      </div>

                      <div
                        className="addunit-form"
                        style={{ maxHeight: "420px", overflowY: "scroll" }}
                      >
                        <div className="table-responsive">
                          <table className="table  align-middle table-text">
                            <thead className="table-head align-middle text-nowrap">
                              <tr>
                                <th>FIELD NAME</th>
                                <th>FIELD TYPE</th>
                                <th>FIELD VALUE</th>
                                <th>DISPLAY NAME</th>
                                <th>REQUIRED</th>
                                <th>ACTIONS</th>
                              </tr>
                            </thead>
                            <tbody>
                              {templateAttributes.map((templateAttribute) => (
                                <tr key={templateAttribute._id}>
                                  <td>{templateAttribute.field_name}</td>
                                  <td>{templateAttribute.field_type}</td>
                                  <td>
                                    {Array.isArray(
                                      templateAttribute.field_value
                                    ) ? (
                                      <div>
                                        {templateAttribute.field_value.map(
                                          (value, index) => (
                                            <div key={index}>{value}</div>
                                          )
                                        )}
                                      </div>
                                    ) : (
                                      templateAttribute.field_value
                                    )}
                                  </td>
                                  <td>{templateAttribute.display_name}</td>
                                  <td>
                                    {templateAttribute.required ? "Yes" : "No"}
                                  </td>
                                  <td>
                                    <div className="action-icons d-flex justify-content-center align-items-center">
                                      <button
                                        style={{
                                          border: "none",
                                          backgroundColor: "transparent",
                                        }}
                                        className="align-content-center me-3"
                                        onClick={() => {
                                          openEditModal(templateAttribute._id);
                                          // closeViewModal();
                                        }}
                                      >
                                        <img src={edit} alt="edit" width={20} />
                                      </button>

                                      <button
                                        style={{
                                          border: "none",
                                          backgroundColor: "transparent",
                                        }}
                                        className="align-content-center"
                                        // onClick = {() => deleteSpecialization(templateAttribute._id, templateAttribute.field_name)}
                                        onClick={() => {
                                          setEditElementId(
                                            templateAttribute._id
                                          );
                                          setEditSpecializationName(
                                            templateAttribute.field_name
                                          );
                                          setConfirmModal(true);
                                        }}
                                      >
                                        <img
                                          src={trash}
                                          alt="trash"
                                          width={20}
                                        />
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className="addunit-card-footer">
                        <button
                          type="button"
                          style={{ width: "100%" }}
                          className="update-btn"
                          onClick={closeAttributeModal}
                        >
                          Close
                        </button>
                        {/**<button type="submit" className="update-btn">
                            Save Changes
                          </button> */}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Modal for edit Specialization*/}
                <div
                  id="overlay"
                  className={`modal fade ${isEditModalOpen ? "show" : ""}`}
                  tabIndex="-1"
                  role="dialog"
                  style={{
                    zIndex: 30,
                    display: isEditModalOpen ? "block" : "none",
                    transition: "width 2s",
                  }}
                >
                  <div>
                    <div
                      className="addunit-card Width 25%"
                      style={{ maxHeight: "500px" }}
                    >
                      <div className="addunit-header">
                        <h4>
                          {editSpecializationName
                            ? editSpecializationName
                            : "Loading"}
                        </h4>
                        <button
                          style={{ border: "none", backgroundColor: "inherit" }}
                          type="button"
                          className="close"
                          onClick={closeEditModal}
                        >
                          <img
                            src={close}
                            width="28px"
                            height="28px"
                            alt="Close"
                          />
                        </button>
                      </div>
                      <form
                        onSubmit={updateSpecification}
                        autoComplete="off"
                        noValidate
                        className="needs-validation"
                      >
                        <div className="addunit-form">
                          <div className="row mb-4">
                            <div className="col">
                              <div className="d-flex flex-column ">
                                <label
                                  htmlFor="fieldName"
                                  className="addunit-form-text"
                                >
                                  Field Name{" "}
                                  <span className="text-danger"> *</span>
                                </label>
                                <input
                                  type="text"
                                  bb
                                  className={`form-control ${errors.field_name ? "is-invalid" : ""
                                    }`}
                                  id="fieldName"
                                  placeholder="Enter the Field Name"
                                  value={editTemplateAttribute.field_name}
                                  onChange={(e) =>
                                    setEditTemplateAttribute({
                                      ...editTemplateAttribute,
                                      field_name: e.target.value,
                                    })
                                  }
                                />
                                {errors.field_name && (
                                  <div className="invalid-feedback">
                                    {errors.field_name}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="col">
                              <div className="d-flex flex-column ">
                                <label
                                  htmlFor="fieldType"
                                  className="addunit-form-text"
                                >
                                  Field Type{" "}
                                  <span className="text-danger"> *</span>
                                </label>
                                <select
                                  className={`form-select select-unit textarea ${errors.field_type ? "is-invalid" : ""
                                    }`}
                                  id="fieldType"
                                  value={editTemplateAttribute.field_type}
                                  onChange={(e) => {
                                    const newFieldType = e.target.value;
                                    setPreviousFieldValue(
                                      newFieldType === "select"
                                        ? previousFieldValue
                                        : editTemplateAttribute.field_value
                                    );
                                    setEditTemplateAttribute({
                                      ...editTemplateAttribute,
                                      field_type: newFieldType,
                                      field_value:
                                        newFieldType === "select"
                                          ? previousFieldValue
                                          : "",
                                    });
                                  }}
                                >
                                  <option disabled value="">
                                    Select
                                  </option>
                                  <option value="string">String</option>
                                  <option value="number">Number</option>
                                  <option value="select">Select</option>
                                  <option value="date">Date</option>
                                  <option value="textarea">Textarea</option>
                                  <option value="file">File</option>
                                  <option value="list">List</option>

                                </select>
                                {errors.field_type && (
                                  <div
                                    className="invalid-feedback"
                                    style={{ color: "red" }}
                                  >
                                    {errors.field_type}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>

                          {editTemplateAttribute.field_type === "list" && (
                            <div className="row">
                              <div className="col-6">
                                <div className="d-flex flex-column mb-4">
                                  <label htmlFor="parameterType" className="addunit-form-text">
                                    Select Parameter Type <span className="text-danger">*</span>
                                  </label>
                                  <select
                                    className="form-select"
                                    id="parameterType"
                                    value={editTemplateAttribute.parameter_type_id || ""}
                                    onChange={(e) => {
                                      const selectedId = e.target.value;
                                      const selectedParam = parameters.find((p) => p._id === selectedId);

                                      setEditTemplateAttribute({
                                        ...editTemplateAttribute,
                                        parameter_type_id: selectedId,
                                        master_id: "", // reset previously selected master
                                      });

                                      setSelectedMasters(selectedParam?.masterDetails || []);
                                    }}
                                  >
                                    <option disabled value="">Select Parameter Type</option>
                                    {parameters.map((param) => (
                                      <option key={param._id} value={param._id}>
                                        {param.parameter_type_name}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                            </div>
                          )}

                          {selectedMasters.length > 0 && editTemplateAttribute.field_type === "list" && (
                            <div className="row">
                              <div className="col-6">
                                <div className="d-flex flex-column mb-4">
                                  <label htmlFor="masterDropdown" className="addunit-form-text">
                                    Select Master <span className="text-danger">*</span>
                                  </label>
                                  {/* <select
                                    className="form-select"
                                    id="masterDropdown"
                                    value={newTemplateAttribute.master_id || ""}
                                    onChange={(e) =>
                                      setNewTemplateAttribute({
                                        ...newTemplateAttribute,
                                        master_id: e.target.value,
                                      })
                                    }
                                  >
                                    <option disabled value="">Select Master</option>
                                    {selectedMasters.map((master) => (
                                      <option key={master.masterId} value={master.masterId}>
                                        {master.masterName}
                                      </option>
                                    ))}
                                  </select> */}
                                  <select
                                    className="form-select"
                                    id="masterDropdown"
                                    value={editTemplateAttribute.master_id || ""}
                                    onChange={async (e) => {
                                      const selectedMasterId = e.target.value;

                                      // Fetch the values from backend
                                      const masterValues = await fetchMasterValues(selectedMasterId); // API call

                                      // Extract only the relevant values (e.g., unit_name or unit_code)
                                      const valueList = masterValues.map((item) => {
                                        const firstKey = Object.keys(item).find(k =>
                                          !["id", "_v", "status", "deleted_at", "created_at", "updated_at"].includes(k)
                                        );
                                        return item[firstKey];
                                      });

                                      // Join them with commas
                                      const commaSeparatedValues = valueList.join(",");

                                      // Update the state
                                      setEditTemplateAttribute((prev) => ({
                                        ...prev,
                                        master_id: selectedMasterId,
                                        // field_value: commaSeparatedValues, // store directly
                                      }));
                                    }}
                                  >
                                    <option disabled value="">Select Master</option>
                                    {selectedMasters.map((master) => (
                                      <option key={master.masterId} value={master.masterId}>
                                        {master.masterName}
                                      </option>
                                    ))}
                                  </select>


                                </div>
                              </div>
                            </div>
                          )}

                          <div className="row">
                            <div className="col-6">
                              <div className="d-flex flex-column mb-4">
                                <label
                                  htmlFor="fieldValue"
                                  className="addunit-form-text"
                                >
                                  Field Value
                                </label>
                                <input
                                  type="text"
                                  className={`form-control ${errors.field_value ? "is-invalid" : ""
                                    }`}
                                  id="fieldValue"
                                  placeholder="Enter the Field Value"
                                  value={editTemplateAttribute.field_value}
                                  onChange={(e) =>
                                    setEditTemplateAttribute({
                                      ...editTemplateAttribute,
                                      field_value: e.target.value,
                                    })
                                  }
                                  disabled={
                                    editTemplateAttribute.field_type !==
                                    "select"
                                  }
                                />
                                {errors.field_value && (
                                  <div className="invalid-feedback">
                                    {errors.field_value}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="col-6 ">
                              <div className="d-flex flex-column mb-4">
                                <label
                                  htmlFor="displayName"
                                  className="addunit-form-text"
                                >
                                  Display Name{" "}
                                  <span className="text-danger"> *</span>
                                </label>
                                <input
                                  type="text"
                                  className={`form-control ${errors.display_name ? "is-invalid" : ""
                                    }`}
                                  id="displayName"
                                  placeholder="Enter the Display Name"
                                  value={editTemplateAttribute.display_name}
                                  onChange={(e) =>
                                    setEditTemplateAttribute({
                                      ...editTemplateAttribute,
                                      display_name: e.target.value,
                                    })
                                  }
                                />
                                {errors.display_name && (
                                  <div className="invalid-feedback">
                                    {errors.display_name}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="d-flex flex-column mb-4">
                              <label
                                htmlFor="required"
                                className="addunit-form-text"
                              >
                                Required <span className="text-danger"> *</span>
                              </label>
                              <select
                                className={`form-select select-unit textarea ${errors.required ? "is-invalid" : ""
                                  }`}
                                id="required"
                                value={editTemplateAttribute.required}
                                onChange={(e) =>
                                  setEditTemplateAttribute({
                                    ...editTemplateAttribute,
                                    required: e.target.value,
                                  })
                                }
                              >
                                <option disabled value="">
                                  Select
                                </option>
                                <option value="true">Yes</option>
                                <option value="false">No</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="addunit-card-footer justify-content-between">
                          <button
                            type="button"
                            className="discard-btn"
                            onClick={closeEditModal}
                          >
                            Close
                          </button>
                          <button type="submit" className="update-btn">
                            Save
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                {/*
0 */}
                <div
                  id="overlay"
                  className={`modal fade ${confirm ? "show" : ""}`}
                  tabIndex="-1"
                  role="dialog"
                  style={{
                    zIndex: 30,
                    display: confirm ? "block" : "none",
                    transition: "width 2s",
                  }}
                >
                  <div>
                    <div className="addunit-card Width 25%">
                      <div className="addunit-header">
                        <h4>
                          Confirm
                        </h4>
                        <button
                          style={{ border: "none", backgroundColor: "inherit" }}
                          type="button"
                          className="close"
                          onClick={() => setConfirm(false)}
                        >

                          <img src={close} width="28px" height="28px" alt="Close" />
                        </button>
                      </div>

                      <div className="delete-unit">


                        <p className="delete-unit-text">
                          Are you sure you want to make this change?
                        </p>
                      </div>

                      <div className="addunit-card-footer justify-content-between">
                        <button
                          type="button"
                          className="discard-btn"
                          onClick={() => setConfirm(false)}
                        >
                          NO
                        </button>
                        <button
                          type="button"
                          className="update-btn"
                          onClick={handleSave}
                        >
                          YES
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {/*Delete Confirmation Modal */}
                <div
                  id="overlay"
                  className={`modal fade ${confirmModal ? "show" : ""}`}
                  tabIndex="-1"
                  role="dialog"
                  style={{
                    zIndex: 30,
                    display: confirmModal ? "block" : "none",
                    transition: "width 2s",
                  }}
                >
                  <div>
                    <div className="addunit-card Width 25%">
                      <div className="addunit-header">
                        <h4>Delete Specialization</h4>
                        <button
                          style={{ border: "none", backgroundColor: "inherit" }}
                          type="button"
                          className="close"
                          onClick={() => setConfirmModal(false)}
                        >
                          <img
                            src={close}
                            width="28px"
                            height="28px"
                            alt="Close"
                          />
                        </button>
                      </div>
                      <div className="addunit-form">
                        <p>
                          Are you sure you want to delete{" "}
                          {editSpecializationName
                            ? editSpecializationName
                            : "loading..."}
                          ?
                        </p>
                      </div>
                      <div className="addunit-card-footer justify-content-between">
                        <button
                          type="button"
                          className="discard-btn"
                          onClick={() => setConfirmModal(false)}
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="update-btn"
                          onClick={confirmAction}
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Modal to select Attributes */}

                <div
                  id="overlay"
                  className={`modal fade ${isAttributeModalOpen ? "show" : ""}`}
                  tabIndex="-1"
                  role="dialog"
                  style={{
                    zIndex: 30,
                    display: isAttributeModalOpen ? "block" : "none",
                    transition: "width 2s",
                  }}
                >
                  <div>
                    <div
                      className="addunit-card Width 25%"
                      style={{ maxHeight: "500px" }}
                    >
                      <div className="addunit-header">
                        <h4>Select Attributes</h4>
                        <button
                          style={{ border: "none", backgroundColor: "inherit" }}
                          type="button"
                          className="close"
                          onClick={closeAttributeModal}
                        >
                          <img
                            src={close}
                            width="28px"
                            height="28px"
                            alt="Close"
                          />
                        </button>
                      </div>

                      <form onSubmit={handleSelectedAttributes}>
                        <div
                          className="addunit-form"
                          style={{ maxHeight: "420px", overflowY: "scroll" }}
                        >
                          <div className="table-responsive">
                            <table className="table align-middle table-text">
                              <thead className="table-head align-middle">
                                <tr>
                                  <th className="table-check">
                                    <input
                                      type="checkbox"
                                      checked={allChecked}
                                      onChange={handleHeaderCheckboxChange}
                                    />
                                  </th>
                                  <th>Display Name</th>
                                  <th>Field Type</th>
                                  <th>Order</th>
                                </tr>
                              </thead>
                              <tbody>
                                {attributes.map((attribute) => (
                                  <tr key={attribute._id}>
                                    <td className="table-check">
                                      <input
                                        type="checkbox"
                                        checked={checkedItems.includes(
                                          attribute._id
                                        )}
                                        onChange={() =>
                                          handleRowCheckboxChange(attribute._id)
                                        }
                                      />
                                    </td>
                                    <td>{attribute.display_name}</td>
                                    <td>{attribute.field_type}</td>
                                    <td>
                                      <input
                                        type="number"
                                        style={{ all: "unset", width: "70px" }}
                                        value={attribute.order}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          if (value >= 1 || value === "") {
                                            handleOrderChange(
                                              attribute._id,
                                              value
                                            );
                                          }
                                        }}
                                        min="1"
                                      />
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div className="addunit-card-footer">
                          <button
                            type="button"
                            className="discard-btn"
                            onClick={closeAttributeModal}
                          >
                            Close
                          </button>
                          <button type="submit" className="update-btn">
                            Save Changes
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>

                {/* Modal to select template master */}
                <div
                  id="overlay"
                  className={`modal fade ${isTemplateModalOpen ? "show" : ""}`}
                  tabIndex="-1"
                  role="dialog"
                  style={{
                    zIndex: 30,
                    display: isTemplateModalOpen ? "block" : "none",
                    transition: "width 2s",
                  }}
                >
                  <div
                    className="addunit-card"
                    style={{ width: "100%", height: "100%" }}
                  >
                    <div className="addunit-header">
                      <h4 className="text-uppercase">
                        {selectedNode && selectedNode.data.label
                          ? selectedNode.data.label
                          : "Loading"}
                      </h4>
                      <button
                        style={{ border: "none", backgroundColor: "inherit" }}
                        type="button"
                        className="close"
                        onClick={closeTemplateModal}
                      >
                        <img
                          src={close}
                          width="28px"
                          height="28px"
                          alt="Close"
                        />
                      </button>
                    </div>

                    <form onSubmit={handleAddAssetMaster}>
                      <div
                        className="addunit-form"
                        style={{
                          height: "calc(100vh - 50px - 72px)",
                          overflowY: "scroll",
                          padding: "0px 10px 0px 10px",
                        }}
                      >
                        {filteredTemplateMasters.map((group) => {
                          // Check if all templates in the group are checked and the group has templates
                          const allChecked =
                            group.templates.length > 0 &&
                            group.templates.every((templateMaster) =>
                              checkedTemplateMasters.some(
                                (item) =>
                                  item.template_master_id === templateMaster._id
                              )
                            );
                          const hasConnectedDocument = group.templates.some(template => template.document_code.includes('-'));
                          return (
                            <div
                              className="table-responsive"
                              key={group.master_name}
                            >
                              <table className="table table-text">
                                <thead className="table-head align-middle">
                                  <tr>
                                    <th
                                      style={{
                                        borderBottomWidth: 0,
                                        width: "60px",
                                      }}
                                      className="table-check"
                                    >
                                      <input
                                        style={{ marginLeft: "10px" }}
                                        type="checkbox"
                                        checked={allChecked}
                                        onChange={() =>
                                          handleMasterHeaderCheckbox(
                                            group.master_name
                                          )
                                        }
                                      />
                                    </th>
                                    <th className="d-flex justify-content-between align-items-center">
                                      <div>{group.master_name}</div>
                                      <div className="d-flex  align-items-center ">
                                        {hasConnectedDocument && (
                                          <div className="table-check me-2">
                                            <label className="d-flex align-items-center">
                                              <input
                                                type="checkbox"
                                                checked={!!uniqueCheckboxes[group.master_name]}
                                                onChange={() => handleUniqueCheckbox(group.master_name)}
                                                className="m-2"
                                              />
                                              Unique
                                            </label>
                                          </div>
                                        )}
                                        <div className="tb-search-div">
                                          <img
                                            src={search1}
                                            className="tg-search-icon"
                                            alt="search icon"
                                          />
                                          <input
                                            className="tb-search-input"
                                            placeholder="search"
                                            style={{
                                              padding: "8px 35px",
                                              height: "42px",
                                            }}
                                            value={
                                              tableSearchQueries[
                                              group.master_name
                                              ] || ""
                                            }
                                            onChange={(e) =>
                                              handleTableSearch(
                                                e,
                                                group.master_name
                                              )
                                            }
                                          />
                                        </div>
                                      </div>
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {group.templates.length > 0 ? (
                                    group.templates.map((templateMaster) => (
                                      <tr key={templateMaster._id}>
                                        <td className="table-check d-flex align-items-center justify-content-center">
                                          <input
                                            type="checkbox"
                                            checked={checkedTemplateMasters.some(
                                              (item) =>
                                                item.template_master_id ===
                                                templateMaster._id
                                            )}
                                            onChange={() =>
                                              handleMasterRowCheckbox(
                                                templateMaster._id,
                                                templateMaster.document_code
                                              )
                                            }
                                          />
                                        </td>
                                        <td>{templateMaster.document_code}</td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan="2" className="text-center">
                                        No Results Found
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          );
                        })}
                      </div>
                      <div
                        className="addunit-card-footer"
                        style={{ position: "absolute", bottom: 0 }}
                      >
                        <button
                          type="button"
                          className="discard-btn"
                          onClick={closeTemplateModal}
                        >
                          CANCEL
                        </button>
                        <button type="submit" className="update-btn">
                          SUBMIT
                        </button>
                      </div>
                    </form>
                  </div>
                </div>

                {/* Modal to add label to an edge */}
                <div
                  id="overlay"
                  className={`modal fade ${edgeLabelModal.isOpen ? "show" : ""
                    }`}
                  tabIndex="-1"
                  role="dialog"
                  style={{
                    zIndex: 30,
                    display: edgeLabelModal.isOpen ? "block" : "none",
                    transition: "width 2s",
                  }}
                >
                  <div>
                    <div className="addunit-card Width 25%">
                      <div className="addunit-header">
                        <h4>Add or Edit Edge Label</h4>
                        <button
                          style={{ border: "none", backgroundColor: "inherit" }}
                          type="button"
                          className="close"
                          onClick={() =>
                            setEdgeLabelModal({
                              isOpen: false,
                              label: "",
                              edgeId: null,
                            })
                          }
                        >
                          <img
                            src={close}
                            width="28px"
                            height="28px"
                            alt="Close"
                          />
                        </button>
                      </div>

                      <div className="addunit-form">
                        <div className="row">
                          <div className="d-flex flex-column">
                            <label
                              htmlFor="edge-name"
                              className="addunit-form-text"
                            >
                              Edge Label
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="edge-name"
                              value={edgeLabelModal.label}
                              onChange={(e) =>
                                setEdgeLabelModal({
                                  ...edgeLabelModal,
                                  label: e.target.value,
                                })
                              }
                            />
                          </div>
                        </div>
                      </div>

                      <div className="addunit-card-footer">
                        <button
                          type="button"
                          className="discard-btn"
                          onClick={() =>
                            setEdgeLabelModal({
                              isOpen: false,
                              label: "",
                              edgeId: null,
                            })
                          }
                        >
                          Close
                        </button>
                        <button
                          type="button"
                          className="update-btn"
                          onClick={() =>
                            addLabelToEdge(
                              edgeLabelModal.edgeId,
                              edgeLabelModal.label
                            )
                          }
                        >
                          Add Label
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <ToastContainer autoClose={4000} position={"top-right"} />
    </>
  );
};

export default EditAsset;
